<template>
    <ai-tree-list-edit
        ref="eoschemaTreeList"
        :args="args"
        :meta="meta"
        :to-remove-toolbar-items-names="toRemoveToolbarItemsNames"
        @dragChange="onDragChange"
        @escapeDownClick="onEscapeDownClick"
    />
</template>
<script setup>
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import { useRoute } from 'vue-router';
import { onMounted, ref } from 'vue';

const eoschemaTreeList = ref();
const route = useRoute();
const args = {
    select: {
        select_args: {
            eobj_id: route.params.id,
        },
    },
    save: {
        update_args: {
            src_id: route.params.id,
        },
    },
};
const meta = {
    keyExpr: 'item_id',
    parentIdExpr: 'parent_item_id',
    viewId: 'widgetEoschema',
    findTool: 'filter',
    firstColumnFields: {
        text: 'name',
        svg: 'asset_svg',
        caption: 'Диспетчерский №',
        allowEditing: false,
    },
    columns: [
        {
            dataField: 'eobj_id',
            dataType: 'number',
            allowEditing: false,
            visible: false,
        },
        {
            dataField: 'kindname',
            caption: 'Вид оборудования',
            allowEditing: false,
            width: 80,
        },
        {
            dataField: 'sv',
            caption: 'Напряжение, кВ',
            allowEditing: false,
            width: 80,
        },
        {
            dataField: 'kod_separator',
            allowEditing: false,
            visible: false,
        },
        {
            dataField: 'bname',
            caption: 'Балансовая принадлежность',
            width: 100,
            allowEditing: false,
        },
        {
            dataField: 'ename',
            caption: 'Эксплуатационная ответственность',
            width: 100,
            allowEditing: false,
        },
        {
            dataField: 'distrobj_kindname',
            caption: 'Вид объекта',
            allowEditing: false,
            width: 80,
        },
        {
            dataField: 'distrobjname',
            caption: 'Объект',
            width: 100,
            allowEditing: false,
        },
        {
            dataField: 'imported',
            caption: 'Импортирован',
            dataType: 'boolean',
            allowEditing: false,
        },
        {
            dataField: 'tech_location_code',
            caption: 'Код технического места оборудования в SAP (или ее аналога)',
            allowEditing: false,
            visible: false,
        },
        {
            dataField: 'pr_sxem',
            caption: 'Признак участия в схеме',
            dataType: 'boolean',
            allowEditing: false,
            visible: false,
        },
    ],
    api: {
        select: 'e-grid./eoschema/get',
        save: 'e-grid./eoschema/set',
    },
    rights: {
        INS: false,
        UPD: true,
        DEL: false,
    },
    selectionMode: 'single',
    dragging: true,
    enableCutAndPut: true,
    autoSaveDragDrop: true,
    autoSaveCutPut: true,
};
const toRemoveToolbarItemsNames = [
    'choice',
    'copy',
    'edit',
    'addSibling',
    'addChild',
    'delete',
    'expandOrCollapseButton',
    'save',
];
const onTreeListCellPrepared = event => {
    if (event.rowType === 'data' && !event.data.parent_item_id) {
        event.cellElement.style.fontWeight = 'bold';
    }
};

onMounted(() => {
    setTimeout(() => {
        eoschemaTreeList.value?.expandAll();
    }, 1000);
    eoschemaTreeList.value.treeListInstance.on('cellPrepared', onTreeListCellPrepared);
});

const onEscapeDownClick = highlightedRowsElements => {
    if (highlightedRowsElements.length) {
        highlightedRowsElements.forEach(element => {
            element.style.backgroundColor = '#FFFFFF';
        });
    }
};

const onDragChange = ({ event, sourceData, targetData }) => {
    const restrictedSources = [-3000, -4000];
    //Не разрешаем дергать узлы "схема - точка входа" и "Оборудование не включенное в группу"
    const isRootRow = restrictedSources.includes(sourceData.item_id);
    //Не разрешаем делать родителем узлы, которые находятся в "Оборудование не включенное в группу"
    const isNotExistRow = event.dropInsideItem && targetData[meta.parentIdExpr] === -4000;
    // //Не разрешать создавать рутовые узлы
    // const isAttemptionRoot = (!event.dropInsideItem && restrictedSources.includes(sourceData.item_id));
    event.cancel = isRootRow || isNotExistRow || !event.dropInsideItem;
};
</script>
